import { PublicLayout } from '../../components/layout/PublicLayout';
import './legal.css';

export function PrivacyPage() {
  return (
    <PublicLayout>
      <div className="legal-page">
        <div className="legal-prose">
          <span className="legal-chip">Privacy policy</span>
          <h1>Privacy policy</h1>
          <p>
            <strong>Draft for legal review.</strong> This policy explains how Sarnia Digital (“we”, “us”) collects, uses and
            protects personal data when you use Sarnia Builder. The service is operated from Guernsey and we comply with UK
            GDPR and the Guernsey data protection regime.
          </p>
          <h2>Data we collect</h2>
          <ul>
            <li>Account details: your name, email address and password hash.</li>
            <li>Usage data: IP address, browser type and dates/times of requests for security and rate limiting.</li>
            <li>Billing data: Stripe customer ID and subscription status. We never see or store full card details.</li>
            <li>Content you create: site text, images and settings, including contact-form submissions emailed to site owners.</li>
          </ul>
          <h2>How we use data</h2>
          <ul>
            <li>To provide, secure and improve the service.</li>
            <li>To send transactional emails such as verification codes and password resets.</li>
            <li>To prevent abuse and meet legal obligations.</li>
          </ul>
          <h2>Cookies</h2>
          <p>
            The application sets one strictly necessary session cookie (`sid`) for authentication. No tracking or advertising
            cookies are used. Published customer sites do not set any cookies from our platform.
          </p>
          <h2>Data sharing</h2>
          <p>We share data only with processors necessary to run the service (Stripe for billing, and an email provider for transactional mail) and where required by law.</p>
          <h2>Retention and deletion</h2>
          <p>
            We keep account data while your account is active. You can delete your account at any time; this removes your
            sites, published pages and uploads. Some logs may be retained for a short period for security.
          </p>
          <h2>Your rights</h2>
          <p>
            You have the right to access, correct, delete or export your personal data, and to object to processing. Contact{' '}
            <a href="mailto:privacy@sarnia.digital">privacy@sarnia.digital</a> to exercise these rights.
          </p>
          <p>Last updated: 1 January 2024.</p>
        </div>
      </div>
    </PublicLayout>
  );
}
